module.exports = __webpack_public_path__ + "img/max-file-check.be4e95fa.svg";